const loading = (quizLoading, crosswordLoading) => {
    return quizLoading || crosswordLoading;
};
export { loading };
